import React from 'react';
import { AllProjectsContainer, PageContainer, ProjectCardContainer } from './index.styles';

import InfoMessageContainer from '../form-input-info-message';
import MainWrapper from '../main-wrapper';
import FormButton from '../button-form';
import NavLink from '../nav-link';
import ProjectCard from '../project-card';
import PageTopicContainer from '../page-topic-container';

const ProjectsAll = ({ projects }) => {
	return (
		<MainWrapper otherClasses="pb-24">
			<PageContainer>
				<PageTopicContainer size="lg:w-2/3" title="پروژه" bottom="mb-5">
					<NavLink to="/user/projects/create">
						<FormButton>ایجاد پروژه جدید</FormButton>
					</NavLink>
				</PageTopicContainer>
				<InfoMessageContainer addClass="lg:w-2/3 flex mt-8 flex-col  mx-auto">
				روی نام پروژه کلیک کنید تا در بک لاگ باز شود 
				</InfoMessageContainer>
				<AllProjectsContainer>
					<ProjectCardContainer>
						{projects.map((project) => <ProjectCard key={project.Id} initialData={project} />)}
					</ProjectCardContainer>
				</AllProjectsContainer>
			</PageContainer>
		</MainWrapper>
	);
};

export default ProjectsAll;
